<template>
  <section class="main">
    <MainCount/>
    <ZonesSlider class="main-section"/>
    <BenefitsList class="main-section"/>
    <Speaker class="main-section"/>
    <Speaker2/>
    <Heroes class="main-section"/>
    <Gallery class="main-section"/>
    <Schedule class="main-section"/>
    <Place class="main-section"/>
<!--    <Timer/>-->
    <Tickets class="main-section"/>
    <BannerJoin/>
    <BannerAbout/>
    <About class="main-section"/>
  </section>
</template>

<script>
import MainCount from "@/components/main/Count";
import ZonesSlider from "@/components/main/ZonesSlider";
import BenefitsList from "@/components/main/BenefitsList";
import Speaker from "@/components/main/Speaker";
import Heroes from "@/components/main/Heroes";
import Gallery from "@/components/main/Gallery";
import Schedule from "@/components/main/Schedule";
import Place from "@/components/main/Place";
import Tickets from "@/components/main/Tickets";
import Timer from "@/components/main/Timer";
import BannerJoin from "@/components/main/BannerJoin";
import BannerAbout from "@/components/main/BannerAbout";
import About from "@/components/main/About";
import Speaker2 from "@/components/main/Speaker2";

export default {
  name: "MainLayout",
  components: {
    Speaker2,
    About,
    BannerAbout,
    BannerJoin,
    Timer, Tickets, Place, Schedule, Gallery, Heroes, Speaker, BenefitsList, ZonesSlider, MainCount
  }
}
</script>
<style lang="scss">
.main {
  overflow-x: hidden;
  background: url(~@/assets/main-bg.png) repeat-y;
  padding-bottom: 60px;
  @include _768 {
    padding-bottom: 120px;
  }

  .main-section {
    padding-top: 50px;
    overflow-x: hidden;
    @include _768 {
      padding-top: 180px;
    }
  }
  .swiper-pagination {
    margin-top: 30px;
  }
}
</style>
